import { render, staticRenderFns } from "./nav-group.vue?vue&type=template&id=4fac5f74&scoped=true&"
import script from "./nav-group.vue?vue&type=script&lang=js&"
export * from "./nav-group.vue?vue&type=script&lang=js&"
import style0 from "./nav-group.vue?vue&type=style&index=0&id=4fac5f74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac5f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fac5f74')) {
      api.createRecord('4fac5f74', component.options)
    } else {
      api.reload('4fac5f74', component.options)
    }
    module.hot.accept("./nav-group.vue?vue&type=template&id=4fac5f74&scoped=true&", function () {
      api.rerender('4fac5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/nav-group.vue"
export default component.exports